import type { AxiosError } from 'axios'
import type { WizardVehicleAdditionalData as Step4FormValues } from 'BrokerTsLib/src/dtos'
import type { Offer } from 'BrokerTsLib/src/dtos/Offer/Offer'
import { createContext, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step4Form } from '../../../containers/carkulka/Step4Form'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { StepsContent } from '../../../context/StepsContext'
import { useGetOffer } from '../../../hooks/useOffer'
import { useSaveStep4, useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'

export const Step4Context = createContext<{ offer: Offer }>({ offer: {} as Offer })

export const Step4 = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId, refetchInsuranceParams, isLoading: isLoadingInsuranceParams } = useContext(insuranceParamsContext)
  const { mutateAsync: saveStep4Async } = useSaveStep4()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()

  const offerId = insuranceParams?.generalParams.selectedOfferId
  const { data: axiosOffer, refetch } = useGetOffer(offerId ?? 0, { enabled: false, gcTime: 0, })
  const offer = axiosOffer?.data ?? {} as Offer

  useEffect(() => {
    if (offerId)
      refetch()
  }, [offerId])

  if (!isLoadingInsuranceParams && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 3) {
    navigate('/carkulka/wizard/too-far', { replace: true })
  }

  const handleSubmit = (values: Step4FormValues) => {
    return new Promise((resolve, reject) =>
      saveStep4Async(values)
        .then((response) => {
          if (values.nextPage == 'next') {
            if ((insuranceParams?.generalParams.lastWizardStep ?? 4) < 5) {
              updateStep({ paramsId: Number(insuranceParamsId), step: 5, stepsStep: 'carkulka' }).
                then(() => {
                  refetchInsuranceParams().then(() => {
                    navigate(`/carkulka/wizard/5/${insuranceParamsId}`)
                  })
                })
            }
            else {
              refetchInsuranceParams().then(() => {
                navigate(`/carkulka/wizard/5/${insuranceParamsId}`)
              })
            }
          } else {
            refetchInsuranceParams()
            window.scrollTo(0, 0)
          }

          resolve(response)
        })
        .catch((err: AxiosError) => {
          if (!(err.response && err.response.status === 400 && err.response.data))
            return

          const data = err.response.data


          reject(err)
        })
        .finally(() => { }))
  }

  return (
    <Step4Context.Provider value={{ offer: offer! }}>
      <Section>
        <Container>
          {isLoadingInsuranceParams && <Loading large={true} />}
          {(!insuranceParamsId || insuranceParams) && !isLoadingInsuranceParams &&
            <StepsContent step={4}>
              <Steps icon="car" />
              <InsuranceInfo />

              <Step4Form onSubmit={handleSubmit} />
            </StepsContent>
          }
        </Container>

        <WizardForbiddenMessage />
      </Section>
    </Step4Context.Provider >
  )
}
